export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-slate-300">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-24 sm:py-32">
        <h1 className="text-4xl font-bold text-white font-['Clash_Display'] mb-2">Terms of Service</h1>
        <p className="text-slate-500 text-sm mb-12">Effective Date: 4/4/2026</p>

        <p className="mb-12 text-slate-400 leading-relaxed">
          Welcome to Tegos Digital. By accessing or using our website and services, you agree to be bound by these Terms of Service. Please read them carefully.
        </p>

        <Section title="1. Services">
          <p>Tegos Digital provides web design, AI automation, branding, SEO, and related digital services. Details of specific services are outlined in individual project agreements or proposals.</p>
        </Section>

        <Section title="2. Use of Our Website">
          <p className="mb-4">By using our website, you agree to:</p>
          <ul className="list-disc list-inside space-y-1 text-slate-400">
            <li>Use the site for lawful purposes only</li>
            <li>Not engage in any conduct that restricts or inhibits use of the site</li>
            <li>Not attempt to gain unauthorized access to any part of the site</li>
          </ul>
        </Section>

        <Section title="3. Intellectual Property">
          <p>All content on this website, including text, graphics, logos, and images, is the property of Tegos Digital and is protected by applicable intellectual property laws. You may not reproduce or distribute any content without our written permission.</p>
        </Section>

        <Section title="4. Project Agreements">
          <p>Services provided to clients are governed by individual project agreements. Payment terms, deliverables, timelines, and revisions will be outlined in those agreements. By engaging our services, you agree to the terms set forth in your project proposal.</p>
        </Section>

        <Section title="5. Limitation of Liability">
          <p>Tegos Digital shall not be liable for any indirect, incidental, or consequential damages arising from the use of our website or services. Our total liability shall not exceed the amount paid for the specific service in question.</p>
        </Section>

        <Section title="6. Third-Party Links">
          <p>Our website may contain links to third-party websites. We are not responsible for the content or privacy practices of those sites. Accessing third-party links is at your own risk.</p>
        </Section>

        <Section title="7. Disclaimer of Warranties">
          <p>Our website and services are provided "as is" without warranties of any kind, either express or implied. We do not warrant that the site will be uninterrupted, error-free, or free of viruses.</p>
        </Section>

        <Section title="8. Changes to These Terms">
          <p>We may update these Terms of Service at any time. Continued use of our website after changes are posted constitutes your acceptance of the revised terms.</p>
        </Section>

        <Section title="9. Governing Law">
          <p>These terms are governed by the laws of the United States. Any disputes shall be resolved in the appropriate courts of jurisdiction.</p>
        </Section>

        <Section title="10. Contact Us" last>
          <p className="mb-2">If you have any questions about these Terms, contact us at:</p>
          <p>Email: <a href="mailto:tegosdigital@gmail.com" className="text-blue-400 hover:text-blue-300">tegosdigital@gmail.com</a></p>
        </Section>

        <p className="mt-12 pt-8 border-t border-[#1F1F22] text-slate-500 text-sm">
          By using our website, you agree to these Terms of Service.
        </p>
      </div>
    </div>
  );
};

const Section = ({ title, children, last }) => (
  <div className={`mb-10 pb-10 ${!last ? 'border-b border-[#1F1F22]' : ''}`}>
    <h2 className="text-2xl font-bold text-white font-['Clash_Display'] mb-4">{title}</h2>
    <div className="text-slate-400 leading-relaxed space-y-2">{children}</div>
  </div>
);
